import { motion } from 'framer-motion';
import { Maximize2 } from 'lucide-react';
import { useDemoTheme } from './DemoThemeContext';

export default function FullscreenPrompt({ onEnter, onDecline }) {
  const { isDark } = useDemoTheme();
  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center p-4" style={{ background: 'var(--d-bg)' }}>
      <motion.div
        initial={{ opacity: 0, scale: 0.96, y: 12 }}
        animate={{ opacity: 1, scale: 1, y: 0 }}
        transition={{ duration: 0.4, ease: [0.16, 1, 0.3, 1] }}
        className="w-full max-w-md rounded-2xl p-8 text-center"
        style={{
          background: 'var(--d-surface)',
          border: '1px solid var(--d-border-str)',
          boxShadow: isDark ? '0 24px 60px rgba(0,0,0,0.6)' : '0 24px 60px rgba(124,58,237,0.1)',
        }}
      >
        <div className="w-14 h-14 rounded-xl flex items-center justify-center mx-auto mb-5"
          style={{ background: 'rgba(124,58,237,0.12)', border: '1px solid rgba(124,58,237,0.2)' }}>
          <Maximize2 size={22} style={{ color: '#a78bfa' }} />
        </div>

        <h2 className="font-semibold text-lg mb-2" style={{ color: 'var(--d-text-hi)' }}>
          Fullscreen Recommended
        </h2>
        <p className="text-sm leading-relaxed mb-7" style={{ color: 'var(--d-text-2)' }}>
          For the best assessment experience, we recommend fullscreen mode. This helps minimize
          distractions and replicates a proctored environment.
        </p>

        <div className="flex flex-col gap-3">
          <button
            data-testid="fullscreen-enter-btn"
            onClick={onEnter}
            className="w-full rounded-xl py-3 text-sm font-semibold transition-all duration-200 hover:opacity-90 active:scale-[0.98] text-white"
            style={{ background: 'linear-gradient(135deg, #7c3aed 0%, #4f46e5 100%)' }}
          >
            Enter Fullscreen
          </button>
          <button
            data-testid="fullscreen-skip-btn"
            onClick={onDecline}
            className="w-full rounded-xl py-3 text-sm font-medium transition-colors"
            style={{ color: 'var(--d-text-2)', background: 'transparent' }}
            onMouseEnter={(e) => (e.currentTarget.style.color = 'var(--d-text-1)')}
            onMouseLeave={(e) => (e.currentTarget.style.color = 'var(--d-text-2)')}
          >
            Continue without fullscreen
          </button>
        </div>
      </motion.div>
    </div>
  );
}
